import React from 'react';
import {
	Box,
	ListItem,
	ListItemText,
	Button,
	Switch,
	useMediaQuery,
	IconButton,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { EmailTypeDetails } from './utils';
import { CustomerFacingEmail } from 'common/modules/emails/types';
import { useTranslation } from 'services/localization';
import { RiMailLine } from 'react-icons/ri';

export interface Props extends EmailTypeDetails {
	onClick: (emailType: CustomerFacingEmail) => void;
	onToggle: (isEnabled: boolean) => void;
	disabled: boolean;
	checked?: boolean;
	noDivider: boolean;
}

const EmailSection = (props: Props) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const {
		heading,
		description,
		onClick,
		emailType,
		onToggle,
		checked = true,
		disabled,
		noDivider,
	} = props;

	return (
		<Box>
			<ListItem
				divider={!noDivider}
				disableGutters={isMobile}
				alignItems="flex-start"
				secondaryAction={
					isMobile ? (
						<IconButton aria-label="email" size="small" onClick={() => onClick(emailType)}>
							<RiMailLine />
						</IconButton>
					) : (
						<Button variant="text" color="primary" onClick={() => onClick(emailType)}>
							{t('emails.test.testBtn', 'Test')}
						</Button>
					)
				}
			>
				<Switch
					color="primary"
					edge="start"
					size="small"
					checked={checked}
					onChange={(e) => onToggle(e.target.checked)}
					disabled={disabled}
					sx={{
						marginTop: '7px',
						marginRight: '12px',
					}}
				/>
				<ListItemText
					primary={heading}
					secondary={isMobile ? '' : description}
					sx={{ color: checked ? 'inherit' : theme.palette.text.disabled }}
				/>
			</ListItem>
		</Box>
	);
};

export default EmailSection;
